export enum MarketPriceProviders {
  BILBASEN_DK = "Bilbasen.dk",
  OTHER = "Other",
}
